import { Injectable } from '@angular/core';


import { Observable } from 'rxjs';
import { ServerConfigModel } from '../../../technical/version/server-config.model';
import { PpbApiService } from './ppb-api.service';

@Injectable({ providedIn: 'root' })
export class ConfigurationResolver  {
  config: ServerConfigModel;

  constructor(private api: PpbApiService) {}

  resolve(): Observable<ServerConfigModel> {
    return this.api.getPublic<ServerConfigModel>('/api/v1/configuration');
  }
}
